export const locale = {
    lang: 'en',
    data: {
        PROJECTS_BOARD_DIALOGS_ATTACHEMENT_DISPLAY_CLOSE: 'Close',
    }
};
